module.exports = __webpack_public_path__ + "static/media/all.a96e460a.svg";